import { useNavigate } from 'react-router-dom';

function NeurudaLogo() {
  return (
    <div className="bg-white rounded-xl px-3 py-1.5 shadow-sm">
      <img
        src={`${process.env.PUBLIC_URL}/neruda_logo_hq.webp`}
        alt="Neruda Tours & Safaris"
        width="150"
        height="50"
        loading="eager"
        onError={(e) => { e.currentTarget.style.opacity = '0'; }}
        className="h-16 w-auto object-contain"
      />
    </div>
  );
}

export default function AdminNavbar() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('admin_token');
    navigate('/');
  };

  return (
    <nav className="bg-brand-green shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <NeurudaLogo />
        <div className="flex items-center gap-3">
          <span className="text-white/60 text-xs font-semibold uppercase tracking-widest hidden sm:block">Admin Panel</span>
          <button
            onClick={logout}
            className="px-4 py-2 border border-brand-gold text-brand-gold rounded hover:bg-brand-gold hover:text-brand-green transition-colors text-sm font-semibold"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
